/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityWithComponentDetails {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityWithComponentDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityWithComponentDetails>): AppSecopsVulnerabilityWithComponentDetails {
        let obj = Object.assign(new AppSecopsVulnerabilityWithComponentDetails(), model);
        AppSecopsVulnerabilityWithComponentDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityWithComponentDetails>): AppSecopsVulnerabilityWithComponentDetails {
        if (!model) return null;
        return AppSecopsVulnerabilityWithComponentDetails.newInstance(<AppSecopsVulnerabilityWithComponentDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityWithComponentDetails) {
        if (!obj) return;

        models.AppSecopsVulnerabilityWithComponentDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityWithComponentDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityWithComponentDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The Unique ID of the vulnerability
     */
    vulnerability_id: string;

    /**
     * List of component IDs which has vulnerability
     */
    affected_components: Array<string>;

}
